require('jquery.flot')
require("../../scss/_variables.scss")

document.addEventListener("turbolinks:load", () => {
  if ($('#horse_weight_params').length !== 0) {
    let heartGirth = parseFloat($('input#horse_weight_heart_girth').val());
    let heartGirthUnit = $('input#horse_weight_heart_girth_unit').val();

    let bodyLength = parseFloat($('input#horse_weight_body_length').val());
    let bodyLengthUnit = $('input#horse_weight_body_length_unit').val();

    if (heartGirthUnit !== "in") {
      heartGirth = parseFloat(heartGirth) * 0.393701
    }

    if (bodyLengthUnit !== "in") {
      bodyLength = parseFloat(bodyLength) * 0.393701
    }

    const horseAgeInMonths = Number($('#horse_weight_year').val()) * 12 + Number($('#horse_weight_month').val());

    const weightFactor = {
      fullgrown: 330,
      yearlings: 301,
      weanlings: 280,
    }

    let factor;
    switch(true) {
      case horseAgeInMonths <= 12:
        factor = 'weanlings'
        break;
      case horseAgeInMonths <= 24:
        factor = 'yearlings'
        break;
      default:
        factor = 'fullgrown'
    }

    const lbsWeight = Math.round(heartGirth * heartGirth * bodyLength / weightFactor[factor]);

    const kgsWeight = Math.round(heartGirth * heartGirth * bodyLength / weightFactor[factor] / 2.205);

    $('#weight-ans').html(`${lbsWeight} lb / ${kgsWeight} kg`)
  }
});
